import { useEffect } from "react";
import "./load.css";
import loader from "./loading.svg";
// import loader from "./Loading.gif";
function CustomLoader() {
  useEffect(() => {
    const head = document.getElementById("header");
    window.scrollTo({ top: 0, behavior: "smooth" });
    document.body.style.overflow = "hidden";
    if (head) {
      head.style.position = "relative";
    }
    return () => {
      document.body.style.overflow = "auto";
      if (head) {
        head.style.position = "fixed";
      }
    };
  }, []);
  return (
    <div className="load-screen load-fade-in">
      <img src={ loader } alt="" />
    </div>
  );
}

export default CustomLoader;
